import { dimensions } from 'gazelle/src/core/analytics/ga-custom-defs';

export default function initAnalyticsRun(
  $q,
  $log,
  $window,
  $document,
  rnClient,
  rnLocale,
  rnApplication
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Deliberately using raw window reference to prevent mocking $window from bypassing this check in testing.
  if (window.__karma__) {
    $log.info('Detected karma tests running.  Not configuring analytics.');
    return;
  }

  addGaTempGlobal();

  $q.all([
    rnClient.getConfig(),
    rnLocale.getBcp47Locale(),
  ]).then(([clientConfig, locale]) => {
    if (!hasGaConsent(clientConfig)) {
      return;
    }
    let analyticsKey = _.get(clientConfig, 'registry.keys.analyticsKey');
    if (!analyticsKey) {
      return;
    }

    gaRunFirst(() => {
      $window.ga('create', analyticsKey, 'auto');
      setFields(clientConfig, locale);
    });

    addGaScript();
  });


  // Adapted from google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
  // Split out adding the temporary GA global from adding the GA script
  // so that we can create the global, add the script, initialize the GA tracker,
  // and then apply the temp queue. GA expects the tracker to be created as the first command,
  // but that's not possible in our env because we dynamically load the GA tracker.
  function addGaTempGlobal(name = 'ga') {
    // Direct GA towards a temporary global for bootstrapping
    $window.GoogleAnalyticsObject = name;

    // Creates an initial ga() function.
    // The queued commands will be executed once analytics.js loads.
    if (!$window[name]) {
      $window[name] = function startBlueTemp() {
        ($window[name].q = $window[name].q || []).push(arguments);
      };

      // Sets the time (as an integer) this tag was executed.
      // Used for timing hits.
      $window[name].l = 1 * new Date();
    }
  }

  function gaRunFirst(callback) {
    if (!$window.ga.q) {
      return callback();
    }

    let gaTempQueue = $window.ga.q;
    $window.ga.q = [];

    callback();

    $window.ga.q.push.apply($window.ga.q, gaTempQueue);
  }

  function hasGaConsent(clientConfig) {
    return _.get(clientConfig, 'consent.performance', false);
  }

  // Adapted from google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
  function addGaScript() {
    // Insert the script tag asynchronously.
    // Inserts above current tag to prevent blocking in addition to using the
    // async attribute.
    let document = $document[0];
    let gaScript = document.createElement('script');
    let currentScript = document.getElementsByTagName('script')[0];
    gaScript.async = true;
    gaScript.src = '//www.google-analytics.com/analytics.js';
    currentScript.parentNode.insertBefore(gaScript, currentScript);
  }

  function setFields(clientConfig, locale) {
    // Use beacon transport to minimize any impact on navigation and performance
    set('transport', 'beacon');

    let entityId = _.get(clientConfig, 'entity.id');
    if (entityId) {
      set('userId', entityId);
      set(dimensions.uid, entityId);
    }

    let managingContextId = _.get(clientConfig, 'managingContext.id');
    if (managingContextId) {
      set(dimensions.orgId, managingContextId);
    }

    let contextId = _.get(clientConfig, 'context.id');
    if (contextId) {
      if (managingContextId) {
        set(dimensions.visitingOrgId, contextId);
      } else {
        set(dimensions.orgId, contextId);
      }
    }

    // entity type will be set by data import in the future
    let entityType = _.get(clientConfig, 'entity.type');
    if (entityType) {
      set(dimensions.entityType, entityType);
    }

    let currentAppId = rnApplication.getCurrentAppId();
    if (currentAppId) {
      set('title', currentAppId);
      set('appName', currentAppId);
      set('appID', currentAppId);
    }

    let experimentId = _.get(clientConfig, 'experiment.id');
    if (experimentId) {
      set('expId', experimentId);
    }

    let variantId = _.get(clientConfig, 'experiment.variant');
    if (variantId !== undefined) {
      set('expVar', variantId);
    }

    set('language', locale);
  }

  function set(name, value) {
    $window.ga('set', name, value);
  }
}




// WEBPACK FOOTER //
// ./components/analytics/analytics.run.js